import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from './../material/material.module';
import { SharedModule } from './../shared/shared.module';
import { EnableG2ReviewsDialogComponent } from './enable-g2-reviews-dialog/enable-g2-reviews-dialog.component';
import { G2ReviewsComponent } from './g2-reviews-home/g2-reviews.component';
import { G2ReviewsRoutingModule } from './g2-reviews-routing.module';

@NgModule({
    declarations: [G2ReviewsComponent, EnableG2ReviewsDialogComponent],
    imports: [CommonModule, G2ReviewsRoutingModule, MaterialModule, SharedModule, ReactiveFormsModule]
})
export class G2ReviewsModule {}
